import {
  faArrowsRepeat as faArrowsRepeatDuotone,
  faBuildingColumns as faBuildingColumnsDuotone,
  faCircleCheck as faCircleCheckDuotone,
  faCloudArrowUp as faCloudArrowUpDuotone,
  faFile as faFileDuotone,
  faFileLines as faFileLinesDuotone,
  faFolderOpen as faFolderOpenDuotone,
  faGaugeSimpleMax as faGaugeSimpleMaxDuotone,
  faGrid2Plus as faGrid2PlusDuotone,
  faLanguage as faLanguageDuotone,
  faListTree as faListTreeDuotone,
  faMemoCircleCheck as faMemoCircleCheckDuotone,
  faMicroscope as faMicroscopeDuotone,
  faPenLine as faPenLineDuotone,
  faQuoteRight as faQuoteRightDuotone,
  faScreenUsers as faScreenUsersDuotone,
  faSparkle as faSparkleDuotone,
  faTelescope as faTelescopeDuotone,
  faThumbsDown as faThumbsDownDuotone,
  faThumbsUp as faThumbsUpDuotone,
  faToolbox as faToolboxDuotone,
  faUpload as faUploadDuotone,
  faUserGroup as faUserGroupDuotone,
  faWrench as faWrenchDuotone,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faAngleDown as faAngleDownLight,
  faAngleLeft as faAngleLeftLight,
  faAngleUp as faAngleUpLight,
  faArrowDown as faArrowDownLight,
  faArrowDownShortWide as faArrowDownShortWideLight,
  faArrowDownToLine as faArrowDownToLineLight,
  faArrowRight as faArrowRightLight,
  faArrowRotateLeft as faArrowRotateLeftLight,
  faArrowRotateRight as faArrowRotateRightLight,
  faArrowsRepeat as faArrowsRepeatLight,
  faArrowsRetweet as faArrowsRetweetLight,
  faArrowsRotate as faArrowsRotateLight,
  faArrowToLeft,
  faArrowTurnDownLeft as faArrowTurnDownLeftLight,
  faArrowUpArrowDown as faArrowUpArrowDownLight,
  faArrowUpLeft as faArrowUpLeftLight,
  faArrowUp as faArrowUpLight,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareLight,
  faArrowUpShortWide as faArrowUpShortWideLight,
  faAsterisk as faAsteriskLight,
  faBadgeCheck as faBadgeCheckLight,
  faBadgePercent,
  faBallotCheck as faBallotCheckLight,
  faBarsFilter as faBarsFilterLight,
  faBolt as faBoltLight,
  faBooks as faBooksLight,
  faBookSparkles as faBookSparklesLight,
  faBug as faBugLight,
  faBuildingColumns as faBuildingColumnsLight,
  faCalendar as faCalendarLight,
  faCartShopping as faCartShoppingLight,
  faChartLine as faChartLineLight,
  faCheckToSlot as faCheckToSlotLight,
  faChevronDown as faChevronDownLight,
  faChevronLeft as faChevronLeftLight,
  faChevronRight as faChevronRightLight,
  faChevronUp as faChevronUpLight,
  faCircleCheck as faCircleCheckLight,
  faClockRotateLeft as faClockRotateLeftLight,
  faClone as faCloneLight,
  faCodeBranch as faCodeBranchLight,
  faCoins as faCoinsLight,
  faComments as faCommentsLight,
  faCompass as faCompassLight,
  faCopy as faCopyLight,
  faDownload as faDownloadLight,
  faEnvelope as faEnvelopeLight,
  faEnvelopeOpenText as faEnvelopeOpenTextLight,
  faExchangeAlt as faExchangeAltLight,
  faEye as faEyeLight,
  faEyeSlash as faEyeSlashLight,
  faFastForward as faFastForwardLight,
  faFileArrowDown as faFileArrowDownLight,
  faFileCircleQuestion as faFileCircleQuestionLight,
  faFilePdf as faFilePdfLight,
  faFileSearch as faFileSearchLight,
  faFiles as faFilesLight,
  faFileWord as faFileWordLight,
  faFilter as faFilterLight,
  faFolderOpen as faFolderOpenLight,
  faGear as faGearLight,
  faGlasses as faGlassesLight,
  faGlobe as faGlobeLight,
  faGraduationCap as faGraduationCapLight,
  faGrid2Plus as faGrid2PlusLight,
  faGripLinesVertical,
  faH1 as faH1Light,
  faH2 as faH2Light,
  faH3 as faH3Light,
  faHandHoldingBox as faHandHoldingBoxLight,
  faHighlighterLine as faHighlighterLineLight,
  faImage as faImageLight,
  faInputText as faInputTextLight,
  faLayerGroup,
  faLeafHeart as faLeafHeartLight,
  faListCheck as faListCheckLight,
  faList as faListLight,
  faListOl as faListOlLight,
  faListTree as faListTreeLight,
  faListUl as faListUlLight,
  faLoader as faLoaderLight,
  faMagnifyingGlassChart as faMagnifyingGlassChartLight,
  faMagnifyingGlass as faMagnifyingGlassLight,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMemoCircleInfo as faMemoCircleInfoLight,
  faMemo as faMemoLight,
  faMemoPad as faMemoPadLight,
  faMerge as faMergeLight,
  faMessageDots as faMessageDotsLight,
  faMessageExclamation as faMessageExclamationLight,
  faMessageLines as faMessageLinesLight,
  faMessageSmile as faMessageSmileLight,
  faMessageText as faMessageTextLight,
  faMinus as faMinusLight,
  faMoneyBillWave as faMoneyBillWaveLight,
  faMoneyCheckPen as faMoneyCheckPenLight,
  faObjectUngroup as faObjectUngroupLight,
  faPaperPlaneTop as faPaperPlaneTopLight,
  faPaste as faPasteLight,
  faPencil as faPencilLight,
  faPenFancy as faPenFancyLight,
  faPen as faPenLight,
  faPenLine as faPenLineLight,
  faPlus as faPlusLight,
  faQuestionCircle as faQuestionCircleLight,
  faQuoteRight as faQuoteRightLight,
  faRectangleHistory as faRectangleHistoryLight,
  faRepeat as faRepeatLight,
  faScaleBalanced as faScaleBalancedLight,
  faScissors as faScissorsLight,
  faSearch as faSearchLight,
  faShareNodes as faShareNodesLight,
  faSidebarFlip as faSidebarFlipLight,
  faSidebar as faSidebarLight,
  faSparkle as faSparkleLight,
  faSquareDashedCirclePlus as faSquareDashedCirclePlusLight,
  faTableColumns as faTableColumnsLight,
  faTable as faTableLight,
  faTags,
  faTasks as faTasksLight,
  faText as faTextLight,
  faThoughtBubble as faThoughtBubbleLight,
  faTrafficLight as faTrafficLightLight,
  faTrashCan as faTrashCanLight,
  faTrash as faTrashLight,
  faUpFromLine as faUpFromLineLight,
  faUpRightAndDownLeftFromCenter,
  faUserCheck as faUserCheckLight,
  faUserGroup as faUserGroupLight,
  faUser as faUserLight,
  faUsers as faUsersLight,
  faWavePulse as faWavePulseLight,
  faWindow as faWindowLight,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons';
import {
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAngleDown,
  faAngleLeft,
  faAnglesLeft,
  faAnglesRight,
  faAngleUp,
  faAppleWhole,
  faArrowDown,
  faArrowDownLeftAndArrowUpRightToCenter,
  faArrowDownShortWide,
  faArrowDownToBracket,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowLeftToLine,
  faArrowRight,
  faArrowRightToLine,
  faArrowRotateLeft,
  faArrowRotateRight,
  faArrowsRepeat,
  faArrowsRetweet,
  faArrowsRotate,
  faArrowTrendUp,
  faArrowTurnDownLeft,
  faArrowUpArrowDown,
  faArrowUpFromBracket,
  faArrowUpLeft,
  faArrowUp as faArrowUpRegular,
  faArrowUpRight,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowUpRightFromSquare,
  faArrowUpShortWide,
  faArrowUpToLine,
  faAsterisk,
  faAt,
  faAtomSimple,
  faBadgeCheck,
  faBallotCheck,
  faBars,
  faBarsFilter,
  faBarsSort,
  faBell,
  faBold,
  faBolt,
  faBook,
  faBookAtlas,
  faBookmark,
  faBookOpen,
  faBooks,
  faBookSparkles,
  faBorderAll,
  faBroom,
  faBroomWide,
  faBug,
  faBuildingColumns,
  faBullhorn,
  faBullseye,
  faCalendar,
  faCapsules,
  faCaretDown,
  faCaretUp,
  faCartShopping,
  faChartLine,
  faCheck,
  faCheckDouble,
  faCheckToSlot,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsLeft,
  faChevronsRight,
  faChevronUp,
  faCircleCheck,
  faCircleChevronDown,
  faCircleChevronLeft,
  faCircleChevronRight,
  faCircleChevronUp,
  faCircleEllipsis,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePause,
  faCirclePlay,
  faCircleQuestion,
  faCircleStop,
  faCircleUser,
  faCircleXmark,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faClone,
  faClose,
  faCloudArrowUp,
  faCloudCheck,
  faCodeBranch,
  faCoins,
  faCommand,
  faCommentQuestion,
  faComments,
  faCompass,
  faCopy,
  faCreditCard,
  faCube,
  faDiploma,
  faDna,
  faDownload,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faEquals,
  faExchangeAlt,
  faExclamationCircle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFeather,
  faFile,
  faFileArrowDown,
  faFileChartColumn,
  faFileCheck,
  faFileCircleCheck,
  faFileCircleExclamation,
  faFileCirclePlus,
  faFileCircleQuestion,
  faFileImage,
  faFileInvoice,
  faFileLines,
  faFileMagnifyingGlass,
  faFilePdf,
  faFilePen,
  faFilePlus,
  faFiles,
  faFileSearch,
  faFileShield,
  faFileUser,
  faFileWord,
  faFilter,
  faFingerprint,
  faFire,
  faFlagPennant,
  faFlask,
  faFolderOpen,
  faFrame,
  faGaugeSimpleMax,
  faGear,
  faGearComplex,
  faGift,
  faGlasses,
  faGlobe,
  faGraduationCap,
  faGrid,
  faGrid2,
  faGrid2Plus,
  faGripDotsVertical,
  faH1,
  faH2,
  faH3,
  faH4,
  faHandHoldingBox,
  faHeart,
  faHeartPulse,
  faHighlighterLine,
  faHouse,
  faICursor,
  faImage,
  faInputText,
  faItalic,
  faKeyboard,
  faLanguage,
  faLeaf,
  faLeafHeart,
  faLifeRing,
  faLightbulb,
  faLink,
  faList,
  faListCheck,
  faListOl,
  faListTimeline,
  faListTree,
  faListUl,
  faLoader,
  faLocationCrosshairs,
  faLock,
  faLockKeyhole,
  faLockOpen,
  faMagicWandSparkles,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMagnifyingGlassMinus as faMagnifyingGlassMinusRegular,
  faMagnifyingGlassPlus as faMagnifyingGlassPlusRegular,
  faMemo,
  faMemoCircleCheck,
  faMemoCircleInfo,
  faMemoPad,
  faMerge,
  faMessageBot,
  faMessageDots,
  faMessageExclamation,
  faMessageLines,
  faMessagePlus,
  faMessageSmile,
  faMessageText,
  faMicrochipAi,
  faMicrophone,
  faMicroscope,
  faMinus,
  faMoneyBillWave,
  faMoneyCheckPen,
  faNote,
  faNotebook,
  faObjectUngroup,
  faPaintbrushPencil,
  faPalette,
  faPaperclip,
  faPaperclipVertical,
  faPaperPlane,
  faPaperPlaneAlt,
  faPaperPlaneTop,
  faParagraph,
  faPartyHorn,
  faPaste,
  faPawSimple,
  faPen,
  faPencil,
  faPenClip,
  faPenFancy,
  faPenLine,
  faPenToSquare,
  faPeriod,
  faPipe,
  faPlay,
  faPlus,
  faPresentationScreen,
  faPrint,
  faQuestionCircle,
  faQuoteRight,
  faRabbitRunning,
  faRectangleHistory,
  faRectangleVerticalHistory,
  faRefresh,
  faRepeat,
  faRocket,
  faRocketLaunch,
  faRotate,
  faScaleBalanced,
  faScissors,
  faScroll,
  faSearch,
  faShareNodes,
  faShield,
  faShieldCheck,
  faShieldExclamation,
  faShieldHalved,
  faShuffle,
  faSidebar,
  faSidebarFlip,
  faSliders,
  faSlidersSimple,
  faSparkle,
  faSparkles,
  faSquareDashedCirclePlus,
  faSquareLeft,
  faSquareList,
  faSquareQuestion,
  faSquareQuote,
  faSquareRight,
  faStar,
  faStars,
  faStethoscope,
  faStop,
  faStrikethrough,
  faSubscript,
  faSuperscript,
  faTable,
  faTableColumns,
  faTasks,
  faTelescope,
  faText,
  faTextSize,
  faTextSlash,
  faThoughtBubble,
  faThumbsDown,
  faThumbsUp,
  faTrafficLight,
  faTrash,
  faTrashCan,
  faTree,
  faTriangleExclamation,
  faUnderline,
  faUnlock,
  faUnlockKeyhole,
  faUpFromLine,
  faUpload,
  faUser,
  faUserCheck,
  faUserGroup,
  faUsers,
  faUserTie,
  faVialVirus,
  faVideo,
  faVolume,
  faVolumeSlash,
  faWandMagicSparkles,
  faWarning,
  faWavePulse,
  faWindow,
  faWindowRestore,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faAlignCenter as faAlignCenterSolid,
  faAlignJustify as faAlignJustifySolid,
  faAlignLeft as faAlignLeftSolid,
  faAlignRight as faAlignRightSolid,
  faAngleLeft as faAngleLeftSolid,
  faAnglesLeft as faAnglesLeftSolid,
  faAnglesRight as faAnglesRightSolid,
  faAngleUp as faAngleUpSolid,
  faArrowDownLeftAndArrowUpRightToCenter as faArrowDownLeftAndArrowUpRightToCenterSolid,
  faArrowDownShortWide as faArrowDownShortWideSolid,
  faArrowDown as faArrowDownSolid,
  faArrowDownToLine as faArrowDownToLineSolid,
  faArrowLeftToLine as faArrowLeftToLineSolid,
  faArrowRight as faArrowRightSolid,
  faArrowRightToLine as faArrowRightToLineSolid,
  faArrowRotateLeft as faArrowRotateLeftSolid,
  faArrowRotateRight as faArrowRotateRightSolid,
  faArrowsRetweet as faArrowsRetweetSolid,
  faArrowTurnDownLeft as faArrowTurnDownLeftSolid,
  faArrowUpShortWide as faArrowUpShortWideSolid,
  faArrowUp as faArrowUpSolid,
  faArrowUpToLine as faArrowUpToLineSolid,
  faAsterisk as faAsteriskSolid,
  faAt as faAtSolid,
  faBadgeCheck as faBadgeCheckSolid,
  faBadgePercent as faBadgePercentSolid,
  faBarsFilter as faBarsFilterSolid,
  faBell as faBellSolid,
  faBolt as faBoltSolid,
  faBook as faBookLight,
  faBookmark as faBookmarkSolid,
  faBookOpen as faBookOpenSolid,
  faBooks as faBooksSolid,
  faBug as faBugSolid,
  faBuildingColumns as faBuildingColumnsSolid,
  faCalendar as faCalendarSolid,
  faCapsules as faCapsulesSolid,
  faCaretDown as faCaretDownSolid,
  faCaretUp as faCaretUpSolid,
  faCartShopping as faCartShoppingSolid,
  faCheck as faCheckSolid,
  faCheckToSlot as faCheckToSlotSolid,
  faChevronDown as faChevronDownSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faChevronUp as faChevronUpSolid,
  faCircleCheck as faCircleCheckSolid,
  faCircleChevronDown as faCircleChevronDownSolid,
  faCircleChevronLeft as faCircleChevronLeftSolid,
  faCircleChevronRight as faCircleChevronRightSolid,
  faCircleChevronUp as faCircleChevronUpSolid,
  faCircleEllipsis as faCircleEllipsisSolid,
  faCircleExclamation as faCircleExclamationSolid,
  faCircleInfo as faCircleInfoSolid,
  faCircleMinus as faCircleMinusSolid,
  faCirclePlay as faCirclePlaySolid,
  faCircleQuestion as faCircleQuestionSolid,
  faCircleStop as faCircleStopSolid,
  faCircleXmark as faCircleXMarkSolid,
  faClock as faClockSolid,
  faClose as faCloseSolid,
  faCloudArrowUp as faCloudArrowUpSolid,
  faCloudCheck as faCloudCheckSolid,
  faCodeBranch as faCodeBranchSolid,
  faCoins as faCoinsSolid,
  faComments as faCommentsSolid,
  faCompass as faCompassSolid,
  faCopy as faCopySolid,
  faDownload as faDownloadSolid,
  faEllipsis as faEllipsisSolid,
  faEllipsisVertical as faEllipsisVerticalSolid,
  faExclamationCircle as faExclamationCircleSolid,
  faExpand as faExpandSolid,
  faExternalLinkAlt as faExternalLinkAltSolid,
  faEyeSlash as faEyeSlashSolid,
  faEye as faEyeSolid,
  faFeather as faFeatherSolid,
  faFileArrowDown as faFileArrowDownSolid,
  faFileCircleExclamation as faFileCircleExclamationSolid,
  faFileLines as faFileLinesSolid,
  faFileSearch as faFileSearchSolid,
  faFile as faFileSolid,
  faFiles as faFilesSolid,
  faFileUser as faFileUserSolid,
  faFilter as faFilterSolid,
  faFlagPennant as faFlagPennantSolid,
  faGearComplex as faGearComplexSolid,
  faGear as faGearSolid,
  faGlasses as faGlassesSolid,
  faGlobe as faGlobeSolid,
  faGrid2Plus as faGrid2PlusSolid,
  faGrid as faGridSolid,
  faGripDotsVertical as faGripDotsVerticalSolid,
  faGripLinesVertical as faGripLinesVerticalSolid,
  faH1 as faH1Solid,
  faH2 as faH2Solid,
  faH3 as faH3Solid,
  faH4 as faH4Solid,
  faHandHoldingBox as faHandHoldingBoxSolid,
  faImage as faImageSolid,
  faLanguage as faLanguageSolid,
  faLightbulb as faLightbulbSolid,
  faListCheck as faListCheckSolid,
  faListOl as faListOlSolid,
  faList as faListSolid,
  faListTimeline as faListTimelineSolid,
  faListUl as faListUlSolid,
  faLoader as faLoaderSolid,
  faLockKeyhole as faLockKeyHoleSolid,
  faLockOpen as faLockOpenSolid,
  faLock as faLockSolid,
  faMagicWandSparkles as faMagicWandSparklesSolid,
  faMagnifyingGlassChart as faMagnifyingGlassChartSolid,
  faMagnifyingGlassMinus as faMagnifyingGlassMinusSolid,
  faMagnifyingGlassPlus as faMagnifyingGlassPlusSolid,
  faMagnifyingGlass as faMagnifyingGlassSolid,
  faMemoCircleCheck as faMemoCircleCheckSolid,
  faMessageDots as faMessageDotsSolid,
  faMessageExclamation as faMessageExclamationSolid,
  faMessageLines as faMessageLinesSolid,
  faMinus as faMinusSolid,
  faMoneyBillWave as faMoneyBillWaveSolid,
  faObjectUngroup as faObjectUngroupSolid,
  faPalette as faPaletteSolid,
  faPaperPlaneAlt as faPaperPlaneAltSolid,
  faPaperPlane as faPaperPlaneSolid,
  faPaperPlaneTop as faPaperPlaneTopSolid,
  faParagraph as faParagraphSolid,
  faPencil as faPencilSolid,
  faPenFancy as faPenFancySolid,
  faPen as faPenSolid,
  faPeriod as faPeriodSolid,
  faPlay as faPlaySolid,
  faPlus as faPlusSolid,
  faPrint as faPrintSolid,
  faQuestionCircle as faQuestionCircleSolid,
  faQuoteRightAlt,
  faQuoteRight as faQuoteRightSolid,
  faRefresh as faRefreshSolid,
  faRepeat as faRepeatSolid,
  faRocket as faRocketSolid,
  faRotate as faRotateLight,
  faScaleBalanced as faScaleBalancedSolid,
  faScissors as faScissorsSolid,
  faSearch as faSearchSolid,
  faShareNodes as faShareNodesSolid,
  faShieldCheck as faShieldCheckSolid,
  faShieldExclamation as faShieldExclamationSolid,
  faShieldHalved as faShieldHalvedSolid,
  faSlidersSimple as faSlidersSimpleSolid,
  faSliders as faSlidersSolid,
  faSparkle as faSparkleSolid,
  faSparkles as faSparklesSolid,
  faSquareLeft as faSquareLeftSolid,
  faSquareRight as faSquareRightSolid,
  faStar as faStarSolid,
  faStars as faStarsSolid,
  faStop as faStopSolid,
  faSubscript as faSubscriptSolid,
  faSuperscript as faSuperscriptSolid,
  faTelescope as faTelescopeSolid,
  faText as faTextSolid,
  faThumbsDown as faThumbsDownSolid,
  faThumbsUp as faThumbsUpSolid,
  faTrashCan as faTrashCanSolid,
  faTrash as faTrashSolid,
  faTriangleExclamation as faTriangleExclamationSolid,
  faUnlockKeyhole as faUnlockKeyholeSolid,
  faUnlock as faUnlockSolid,
  faUpFromLine as faUpFromLineSolid,
  faUpload as faUploadSolid,
  faUserCheck as faUserCheckSolid,
  faUser as faUserSolid,
  faUsers as faUsersSolid,
  faVolumeSlash as faVolumeSlashSolid,
  faVolume as faVolumeSolid,
  faWarning as faWarningSolid,
  faWavePulse as faWavePulseSolid,
  faXmark as faXmarkSolid,
  faFileMagnifyingGlass as fileMagnifyingGlassSolid,
} from '@fortawesome/pro-solid-svg-icons';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';

import { AccessibleIcon } from '../accessible-icon';

export const icons = {
  externalLinkAlt: {
    defaultLabel: 'External link',
    variants: {
      regular: faExternalLinkAlt,
      solid: faExternalLinkAltSolid,
    },
  },
  sidebar: {
    defaultLabel: 'Sidebar',
    variants: {
      light: faSidebarLight,
      regular: faSidebar,
    },
  },
  sidebarFlip: {
    defaultLabel: 'Sidebar Flip',
    variants: {
      light: faSidebarFlipLight,
      regular: faSidebarFlip,
    },
  },
  paperclipVertical: {
    defaultLabel: 'Paperclip vertical',
    variants: {
      regular: faPaperclipVertical,
    },
  },
  paperpalDocs: {
    defaultLabel: 'Paperpal Docs',
    variants: {
      regular: faFile,
    },
  },
  paintbrushPencil: {
    defaultLabel: 'paintbrushPencil',
    variants: {
      regular: faPaintbrushPencil,
    },
  },
  fileImage: {
    defaultLabel: 'fileImage',
    variants: {
      regular: faFileImage,
    },
  },
  frame: {
    defaultLabel: 'frame',
    variants: {
      regular: faFrame,
    },
  },
  cube: {
    defaultLabel: 'cube',
    variants: {
      regular: faCube,
    },
  },
  appleWhole: {
    defaultLabel: 'appleWhole',
    variants: {
      regular: faAppleWhole,
    },
  },
  stethoscope: {
    defaultLabel: 'stethoscope',
    variants: {
      regular: faStethoscope,
    },
  },
  heartPulse: {
    defaultLabel: 'heartPulse',
    variants: {
      regular: faHeartPulse,
    },
  },
  pawSimple: {
    defaultLabel: 'pawSimple',
    variants: {
      regular: faPawSimple,
    },
  },
  leaf: {
    defaultLabel: 'leaf',
    variants: {
      regular: faLeaf,
    },
  },
  microscope: {
    defaultLabel: 'microscope',
    variants: {
      duotone: faMicroscopeDuotone,
      regular: faMicroscope,
    },
  },
  atomSimple: {
    defaultLabel: 'atomSimple',
    variants: {
      regular: faAtomSimple,
    },
  },
  dna: {
    defaultLabel: 'dna',
    variants: {
      regular: faDna,
    },
  },
  flask: {
    defaultLabel: 'flask',
    variants: {
      regular: faFlask,
    },
  },
  tree: {
    defaultLabel: 'tree',
    variants: {
      regular: faTree,
    },
  },
  borderAll: {
    defaultLabel: 'borderAll',
    variants: {
      regular: faBorderAll,
    },
  },
  circleExclamation: {
    defaultLabel: 'circleExclamation',
    variants: {
      regular: faCircleExclamation,
      solid: faCircleExclamationSolid,
    },
  },
  fileCircleExclamation: {
    defaultLabel: 'File Circle Exclamation',
    variants: {
      regular: faFileCircleExclamation,
      solid: faFileCircleExclamationSolid,
    },
  },
  filePlus: {
    defaultLabel: 'filePlus',
    variants: {
      regular: faFilePlus,
    },
  },
  filePen: {
    defaultLabel: 'FilePen',
    variants: {
      regular: faFilePen,
    },
  },
  diploma: {
    defaultLabel: 'Diploma',
    variants: {
      regular: faDiploma,
    },
  },
  note: {
    defaultLabel: 'Note',
    variants: {
      regular: faNote,
    },
  },
  fileChartColumn: {
    defaultLabel: 'FileChartColumn',
    variants: {
      regular: faFileChartColumn,
    },
  },
  scroll: {
    defaultLabel: 'Scroll',
    variants: {
      regular: faScroll,
    },
  },
  presentationScreen: {
    defaultLabel: 'PresentationScreen',
    variants: {
      regular: faPresentationScreen,
    },
  },
  vialVirus: {
    defaultLabel: 'VialVirus',
    variants: {
      regular: faVialVirus,
    },
  },
  video: {
    defaultLabel: 'video',
    variants: {
      regular: faVideo,
    },
  },
  period: {
    defaultLabel: 'Period',
    variants: {
      regular: faPeriod,
      solid: faPeriodSolid,
    },
  },
  volume: {
    defaultLabel: 'Volume',
    variants: {
      regular: faVolume,
      solid: faVolumeSolid,
    },
  },
  volumeSlash: {
    defaultLabel: 'VolumeSlash',
    variants: {
      regular: faVolumeSlash,
      solid: faVolumeSlashSolid,
    },
  },
  bookAtlas: {
    defaultLabel: 'BookAtlas',
    variants: {
      regular: faBookAtlas,
    },
  },
  windowRestore: {
    defaultLabel: 'WindowRestore',
    variants: {
      regular: faWindowRestore,
    },
  },
  bookOpen: {
    defaultLabel: 'bookOpen',
    variants: {
      regular: faBookOpen,
      solid: faBookOpenSolid,
    },
  },
  fileCircleCheck: {
    defaultLabel: 'fileCircleCheck',
    variants: {
      regular: faFileCircleCheck,
    },
  },
  userTie: {
    defaultLabel: 'UserTie',
    variants: {
      regular: faUserTie,
    },
  },
  bolt: {
    defaultLabel: 'Bolt',
    variants: {
      regular: faBolt,
      light: faBoltLight,
      solid: faBoltSolid,
    },
  },
  arrowsRotate: {
    defaultLabel: 'Rotating arrow',
    variants: {
      regular: faArrowsRotate,
      light: faArrowsRotateLight,
    },
  },
  bold: {
    defaultLabel: 'Bold',
    variants: {
      regular: faBold,
    },
  },
  italic: {
    defaultLabel: 'Italic',
    variants: {
      regular: faItalic,
    },
  },
  keyboard: {
    defaultLabel: 'Keyboard',
    variants: {
      regular: faKeyboard,
    },
  },
  underline: {
    defaultLabel: 'Underline',
    variants: {
      regular: faUnderline,
    },
  },
  fileInvoice: {
    defaultLabel: 'File invoice',
    variants: {
      regular: faFileInvoice,
    },
  },
  caretDown: {
    defaultLabel: 'Caret Down',
    variants: {
      regular: faCaretDown,
      solid: faCaretDownSolid,
    },
  },
  caretUp: {
    defaultLabel: 'Caret Up',
    variants: {
      regular: faCaretUp,
      solid: faCaretUpSolid,
    },
  },
  cartShopping: {
    defaultLabel: 'Cart shopping',
    variants: {
      regular: faCartShopping,
      solid: faCartShoppingSolid,
      light: faCartShoppingLight,
    },
  },
  bookSparkles: {
    defaultLabel: 'Book sparkles',
    variants: {
      regular: faBookSparkles,
      light: faBookSparklesLight,
    },
  },
  graduationCap: {
    defaultLabel: 'Graduation cap',
    variants: {
      regular: faGraduationCap,
      light: faGraduationCapLight,
    },
  },
  leafHeart: {
    defaultLabel: 'Leaf heart',
    variants: {
      regular: faLeafHeart,
      light: faLeafHeartLight,
    },
  },
  merge: {
    defaultLabel: 'Merge',
    variants: {
      regular: faMerge,
      light: faMergeLight,
    },
  },
  strikethrough: {
    defaultLabel: 'Strikethrough',
    variants: {
      regular: faStrikethrough,
    },
  },
  equal: {
    defaultLabel: 'Equal',
    variants: {
      regular: faEquals,
    },
  },
  command: {
    defaultLabel: 'Command',
    variants: {
      regular: faCommand,
    },
  },
  subscript: {
    defaultLabel: 'Subscript',
    variants: {
      regular: faSubscript,
      solid: faSubscriptSolid,
    },
  },
  superscript: {
    defaultLabel: 'Superscript',
    variants: {
      regular: faSuperscript,
      solid: faSuperscriptSolid,
    },
  },
  squareQuestion: {
    defaultLabel: 'Square question',
    variants: {
      regular: faSquareQuestion,
    },
  },
  badgeCheck: {
    defaultLabel: 'Badge check',
    variants: {
      light: faBadgeCheckLight,
      regular: faBadgeCheck,
      solid: faBadgeCheckSolid,
    },
  },
  bug: {
    defaultLabel: 'Bug',
    variants: {
      light: faBugLight,
      regular: faBug,
      solid: faBugSolid,
    },
  },
  Calendar: {
    defaultLabel: 'Calendar',
    variants: {
      regular: faCalendar,
      light: faCalendarLight,
      solid: faCalendarSolid,
    },
  },
  bell: {
    defaultLabel: 'Bell',
    variants: {
      regular: faBell,
      solid: faBellSolid,
    },
  },
  paragraph: {
    defaultLabel: 'Paragraph',
    variants: {
      regular: faParagraph,
      solid: faParagraphSolid,
    },
  },
  h1: {
    defaultLabel: 'H1',
    variants: {
      regular: faH1,
      light: faH1Light,
      solid: faH1Solid,
    },
  },
  h2: {
    defaultLabel: 'H2',
    variants: {
      regular: faH2,
      light: faH2Light,
      solid: faH2Solid,
    },
  },
  h3: {
    defaultLabel: 'H3',
    variants: {
      regular: faH3,
      light: faH3Light,
      solid: faH3Solid,
    },
  },
  h4: {
    defaultLabel: 'H4',
    variants: {
      regular: faH4,
      solid: faH4Solid,
    },
  },
  heart: {
    defaultLabel: 'Heart',
    variants: {
      regular: faHeart,
    },
  },
  rocket: {
    defaultLabel: 'Rocket',
    variants: {
      solid: faRocketSolid,
      regular: faRocket,
    },
  },
  rotate: {
    defaultLabel: 'Rotate',
    variants: {
      regular: faRotate,
      light: faRotateLight,
    },
  },
  rotateLeft: {
    defaultLabel: 'Rotate left',
    variants: {
      regular: faArrowRotateLeft,
      solid: faArrowRotateLeftSolid,
    },
  },
  rotateRight: {
    defaultLabel: 'Rotate right',
    variants: {
      regular: faArrowRotateRight,
      solid: faArrowRotateRightSolid,
    },
  },
  circleCheck: {
    defaultLabel: 'Circle Check',
    variants: {
      light: faCircleCheckLight,
      regular: faCircleCheck,
      solid: faCircleCheckSolid,
      duotone: faCircleCheckDuotone,
    },
  },
  circleStop: {
    defaultLabel: 'Circle stop',
    variants: {
      regular: faCircleStop,
      solid: faCircleStopSolid,
    },
  },
  shareNodes: {
    defaultLabel: 'Share nodes',
    variants: {
      regular: faShareNodes,
      light: faShareNodesLight,
      solid: faShareNodesSolid,
    },
  },
  stop: {
    defaultLabel: 'Stop',
    variants: {
      regular: faStop,
      solid: faStopSolid,
    },
  },
  TriangleExclamation: {
    defaultLabel: 'Triangle exclamation',
    variants: {
      regular: faTriangleExclamation,
      solid: faTriangleExclamationSolid,
    },
  },
  circleXmark: {
    defaultLabel: 'Circle Xmark',
    variants: {
      regular: faCircleXmark,
      solid: faCircleXMarkSolid,
    },
  },
  broom: {
    defaultLabel: 'Broom',
    variants: {
      regular: faBroom,
    },
  },
  broomWide: {
    defaultLabel: 'Wide broom',
    variants: {
      regular: faBroomWide,
    },
  },
  check: {
    defaultLabel: 'Check',
    variants: {
      regular: faCheck,
      solid: faCheckSolid,
    },
  },
  faCheckSolid: {
    defaultLabel: 'CheckSolid',
    variants: {
      regular: faCheckSolid,
      solid: faCheckSolid,
    },
  },
  chevronDown: {
    defaultLabel: 'Chevron down',
    variants: {
      regular: faChevronDown,
      solid: faChevronDownSolid,
      light: faChevronDownLight,
    },
  },
  chevronUp: {
    defaultLabel: 'Chevron up',
    variants: {
      regular: faChevronUp,
      solid: faChevronUpSolid,
      light: faChevronUpLight,
    },
  },
  arrowLeft: {
    defaultLabel: 'Arrow left',
    variants: {
      regular: faArrowLeft,
    },
  },
  circleInfo: {
    defaultLabel: 'Circle info',
    variants: {
      regular: faCircleInfo,
      solid: faCircleInfoSolid,
    },
  },
  clipboard: {
    defaultLabel: 'Clipboard',
    variants: {
      regular: faClipboard,
    },
  },
  codeBranch: {
    defaultLabel: 'Code branch',
    variants: {
      regular: faCodeBranch,
      solid: faCodeBranchSolid,
      light: faCodeBranchLight,
    },
  },
  copy: {
    defaultLabel: 'Copy',
    variants: {
      regular: faCopy,
      solid: faCopySolid,
      light: faCopyLight,
    },
  },
  download: {
    defaultLabel: 'Download',
    variants: {
      regular: faDownload,
      light: faDownloadLight,
      solid: faDownloadSolid,
    },
  },
  arrowRotateLeft: {
    defaultLabel: 'Arrow rotate left',
    variants: {
      regular: faArrowRotateLeft,
      light: faArrowRotateLeftLight,
      solid: faArrowRotateLeftSolid,
    },
  },
  arrowRotateRight: {
    defaultLabel: 'Arrow rotate right',
    variants: {
      regular: faArrowRotateRight,
      light: faArrowRotateRightLight,
      solid: faArrowRotateRightSolid,
    },
  },
  exclamationCircle: {
    defaultLabel: 'Error',
    variants: {
      solid: faExclamationCircleSolid,
      regular: faExclamationCircle,
    },
  },
  feather: {
    defaultLabel: 'Feather',
    variants: {
      regular: faFeather,
      solid: faFeatherSolid,
    },
  },
  gift: {
    defaultLabel: 'Gift',
    variants: {
      regular: faGift,
    },
  },
  globe: {
    defaultLabel: 'Globe',
    variants: {
      regular: faGlobe,
      solid: faGlobeSolid,
      light: faGlobeLight,
    },
  },
  lightbulb: {
    defaultLabel: 'Light bulb',
    variants: {
      regular: faLightbulb,
      solid: faLightbulbSolid,
    },
  },
  file: {
    defaultLabel: 'File',
    variants: {
      regular: faFile,
      solid: faFileSolid,
      duotone: faFileDuotone,
    },
  },
  fileShield: {
    defaultLabel: 'File Shield',
    variants: {
      regular: faFileShield,
    },
  },
  FileSearch: {
    defaultLabel: 'File Search',
    variants: {
      regular: faFileSearch,
      solid: faFileSearchSolid,
      light: faFileSearchLight,
    },
  },
  fileArrowDown: {
    defaultLabel: 'File Arrow Down',
    variants: {
      regular: faFileArrowDown,
      solid: faFileArrowDownSolid,
      light: faFileArrowDownLight,
    },
  },
  fileUser: {
    defaultLabel: 'File User',
    variants: {
      regular: faFileUser,
      solid: faFileUserSolid,
    },
  },
  cloudArrowUp: {
    defaultLabel: 'Cloud Arrow Up',
    variants: {
      regular: faCloudArrowUp,
      solid: faCloudArrowUpSolid,
      duotone: faCloudArrowUpDuotone,
    },
  },
  clock: {
    defaultLabel: 'Clock',
    variants: {
      regular: faClock,
      solid: faClockSolid,
    },
  },
  history: {
    defaultLabel: 'history',
    variants: {
      regular: faClockRotateLeft,
      light: faClockRotateLeftLight,
    },
  },
  faq: {
    defaultLabel: 'faq',
    variants: {
      regular: faCircleQuestion,
      solid: faCircleQuestionSolid,
    },
  },
  howWorks: {
    defaultLabel: 'howWorks',
    variants: {
      regular: faFileCircleQuestion,
      light: faFileCircleQuestionLight,
    },
  },
  locationCrosshairs: {
    defaultLabel: 'Location crosshairs',
    variants: {
      regular: faLocationCrosshairs,
    },
  },
  magnifyingGlass: {
    defaultLabel: 'Magnifying glass',
    variants: {
      light: faMagnifyingGlassLight,
      solid: faMagnifyingGlassSolid,
      regular: faMagnifyingGlass,
    },
  },
  magnifyingGlassChart: {
    defaultLabel: 'Magnifying glass Chart',
    variants: {
      solid: faMagnifyingGlassChartSolid,
      regular: faMagnifyingGlassChart,
      light: faMagnifyingGlassChartLight,
    },
  },
  fileMagnifyingGlass: {
    defaultLabel: 'File Magnifying glass',
    variants: {
      regular: faFileMagnifyingGlass,
      solid: fileMagnifyingGlassSolid,
    },
  },
  pencile: {
    defaultLabel: 'Pencile',
    variants: {
      regular: faPencil,
      light: faPencilLight,
      solid: faPencilSolid,
    },
  },
  coins: {
    defaultLabel: 'Coins',
    variants: {
      light: faCoinsLight,
      solid: faCoinsSolid,
      regular: faCoins,
    },
  },
  comments: {
    defaultLabel: 'comments',
    variants: {
      regular: faComments,
      solid: faCommentsSolid,
      light: faCommentsLight,
    },
  },
  inputText: {
    defaultLabel: 'Input Text',
    variants: {
      regular: faInputText,
      light: faInputTextLight,
    },
  },
  memo: {
    defaultLabel: 'Memo',
    variants: {
      regular: faMemo,
      light: faMemoLight,
    },
  },
  memoPad: {
    defaultLabel: 'Memo Pad',
    variants: {
      regular: faMemoPad,
      light: faMemoPadLight,
    },
  },
  memoCircleCheck: {
    defaultLabel: 'Memo Circle Check',
    variants: {
      regular: faMemoCircleCheck,
      solid: faMemoCircleCheckSolid,
      duotone: faMemoCircleCheckDuotone,
    },
  },
  memoCircleInfo: {
    defaultLabel: 'Memo Circle Info',
    variants: {
      regular: faMemoCircleInfo,
      light: faMemoCircleInfoLight,
    },
  },
  messageText: {
    defaultLabel: 'Message Text',
    variants: {
      regular: faMessageText,
      light: faMessageTextLight,
    },
  },
  minus: {
    defaultLabel: 'Minus',
    variants: {
      regular: faMinus,
      light: faMinusLight,
    },
  },
  microphone: {
    defaultLabel: 'Microphone',
    variants: {
      regular: faMicrophone,
    },
  },
  messageSmile: {
    defaultLabel: 'Message Smile',
    variants: {
      regular: faMessageSmile,
      light: faMessageSmileLight,
    },
  },
  rectangleHistory: {
    defaultLabel: 'Rectangle History',
    variants: {
      regular: faRectangleHistory,
      light: faRectangleHistoryLight,
    },
  },
  rectangleVerticalHistory: {
    defaultLabel: 'Rectangle Vertical History',
    variants: {
      regular: faRectangleVerticalHistory,
    },
  },
  highlighterLine: {
    defaultLabel: 'Highlighter Line',
    variants: {
      regular: faHighlighterLine,
      light: faHighlighterLineLight,
    },
  },
  messageExclamation: {
    defaultLabel: 'Message',
    variants: {
      regular: faMessageExclamation,
      solid: faMessageExclamationSolid,
      light: faMessageExclamationLight,
    },
  },
  shieldHalved: {
    defaultLabel: 'Shield',
    variants: {
      regular: faShieldHalved,
      solid: faShieldHalvedSolid,
    },
  },
  circleEllipsis: {
    defaultLabel: 'Circle ellipsis',
    variants: {
      regular: faCircleEllipsis,
      solid: faCircleEllipsisSolid,
    },
  },
  listCheck: {
    defaultLabel: 'List Check',
    variants: {
      regular: faListCheck,
      light: faListCheckLight,
      solid: faListCheckSolid,
    },
  },
  lifeRing: {
    defaultLabel: 'Life Ring',
    variants: {
      regular: faLifeRing,
    },
  },
  doubleCheck: {
    defaultLabel: 'Double Check',
    variants: {
      regular: faCheckDouble,
    },
  },
  replace: {
    defaultLabel: 'Replace',
    variants: {
      regular: faExchangeAlt,
      light: faExchangeAltLight,
    },
  },
  lock: {
    defaultLabel: 'Lock',
    variants: {
      regular: faLock,
      solid: faLockSolid,
    },
  },
  lockOpen: {
    defaultLabel: 'Open lock',
    variants: {
      regular: faLockOpen,
      solid: faLockOpenSolid,
    },
  },
  paperPlane: {
    defaultLabel: 'Paper plane',
    variants: {
      regular: faPaperPlane,
      solid: faPaperPlaneSolid,
    },
  },
  paperPlaneAlt: {
    defaultLabel: 'Paper plane',
    variants: {
      regular: faPaperPlaneAlt,
      solid: faPaperPlaneAltSolid,
    },
  },
  faMinusSolid: {
    defaultLabel: 'Minus',
    variants: {
      regular: faMinusSolid,
      solid: faMinusSolid,
    },
  },
  faClose: {
    defaultLabel: 'Close icon',
    variants: {
      regular: faClose,
      solid: faCloseSolid,
    },
  },
  refresh: {
    defaultLabel: 'Refresh',
    variants: {
      regular: faRefresh,
      solid: faRefreshSolid,
    },
  },
  scissors: {
    defaultLabel: 'Scissors',
    variants: {
      regular: faScissors,
      light: faScissorsLight,
      solid: faScissorsSolid,
    },
  },
  shuffle: {
    defaultLabel: 'Shuffle',
    variants: {
      regular: faShuffle,
    },
  },
  sliders: {
    defaultLabel: 'Sliders',
    variants: {
      regular: faSliders,
      solid: faSlidersSolid,
    },
  },
  cloudCheck: {
    defaultLabel: 'cloud check',
    variants: {
      regular: faCloudCheck,
      solid: faCloudCheckSolid,
    },
  },
  star: {
    defaultLabel: 'Star',
    variants: {
      regular: faStar,
      solid: faStarSolid,
    },
  },
  stars: {
    defaultLabel: 'Stars',
    variants: {
      regular: faStars,
      solid: faStarsSolid,
    },
  },
  thumbsDown: {
    defaultLabel: 'Thumbs Down',
    variants: {
      regular: faThumbsDown,
      solid: faThumbsDownSolid,
      duotone: faThumbsDownDuotone,
    },
  },
  thumbsUp: {
    defaultLabel: 'Thumbs Up',
    variants: {
      regular: faThumbsUp,
      solid: faThumbsUpSolid,
      duotone: faThumbsUpDuotone,
    },
  },
  upload: {
    defaultLabel: 'Upload',
    variants: {
      regular: faUpload,
      solid: faUploadSolid,
      duotone: faUploadDuotone,
    },
  },
  arrowUpFromBracket: {
    defaultLabel: 'Arrow Up From Bracket',
    variants: {
      regular: faArrowUpFromBracket,
    },
  },
  gear: {
    defaultLabel: 'Settings',
    variants: {
      regular: faGear,
      light: faGearLight,
      solid: faGearSolid,
    },
  },
  gearComplex: {
    defaultLabel: 'Complex settings',
    variants: {
      regular: faGearComplex,
      solid: faGearComplexSolid,
    },
  },
  ellipsisVertical: {
    defaultLabel: 'Ellipsis vertical',
    variants: {
      regular: faEllipsisVertical,
      solid: faEllipsisVerticalSolid,
    },
  },
  ellipsis: {
    defaultLabel: 'Ellipsis',
    variants: {
      regular: faEllipsis,
      solid: faEllipsisSolid,
    },
  },
  envelopeOpenText: {
    defaultLabel: 'Envelope',
    variants: {
      regular: faEnvelopeOpenText,
      light: faEnvelopeOpenTextLight,
    },
  },
  warning: {
    defaultLabel: 'warning',
    variants: {
      regular: faWarning,
      solid: faWarningSolid,
    },
  },
  wordFile: {
    defaultLabel: 'Word file',
    variants: {
      regular: faFileWord,
      light: faFileWordLight,
    },
  },
  pdfFile: {
    defaultLabel: 'Pdf file',
    variants: {
      regular: faFilePdf,
      light: faFilePdfLight,
    },
  },
  x: {
    defaultLabel: 'X',
    variants: {
      regular: faXmark,
      solid: faXmarkSolid,
    },
  },
  moneyBillWave: {
    defaultLabel: 'money bill wave',
    variants: {
      light: faMoneyBillWaveLight,
      regular: faMoneyBillWave,
      solid: faMoneyBillWaveSolid,
    },
  },

  pipe: {
    defaultLabel: 'Pipe',
    variants: {
      regular: faPipe,
    },
  },
  partyHorn: {
    defaultLabel: 'Party Horn',
    variants: {
      regular: faPartyHorn,
    },
  },
  thoughtBubble: {
    defaultLabel: 'Thought Bubble',
    variants: {
      regular: faThoughtBubble,
      light: faThoughtBubbleLight,
    },
  },
  feedChecks: {
    defaultLabel: 'Feed Checks',
    variants: {
      regular: faBallotCheck,
    },
  },
  arrowUpRight: {
    defaultLabel: 'Arrow Up Right',
    variants: {
      regular: faArrowUpRight,
    },
  },
  faCompass: {
    defaultLabel: 'Compass Arrow',
    variants: {
      regular: faCompass,
      light: faCompassLight,
      solid: faCompassSolid,
    },
  },
  sparkles: {
    defaultLabel: 'Sparkles',
    variants: {
      regular: faSparkles,
      solid: faSparklesSolid,
    },
  },
  arrowUpBracket: {
    defaultLabel: 'Arrow Up Bracket',
    variants: {
      regular: faArrowUpFromBracket,
    },
  },
  arrowDownBracket: {
    defaultLabel: 'Arrow Down Bracket',
    variants: {
      regular: faArrowDownToBracket,
    },
  },
  bullseye: {
    defaultLabel: 'Bullseye',
    variants: {
      regular: faBullseye,
    },
  },
  repeat: {
    defaultLabel: 'Repeat',
    variants: {
      regular: faRepeat,
      solid: faRepeatSolid,
      light: faRepeatLight,
    },
  },
  ChartLine: {
    defaultLabel: 'Chart line',
    variants: {
      regular: faChartLine,
      light: faChartLineLight,
    },
  },
  Users: {
    defaultLabel: 'Users',
    variants: {
      regular: faUsers,
      light: faUsersLight,
      solid: faUsersSolid,
    },
  },
  Books: {
    defaultLabel: 'Books',
    variants: {
      regular: faBooks,
      light: faBooksLight,
      solid: faBooksSolid,
    },
  },
  glasses: {
    defaultLabel: 'Glasses',
    variants: {
      regular: faGlasses,
      light: faGlassesLight,
      solid: faGlassesSolid,
    },
  },
  buildingColumns: {
    defaultLabel: 'Building Columns',
    variants: {
      regular: faBuildingColumns,
      light: faBuildingColumnsLight,
      solid: faBuildingColumnsSolid,
      duotone: faBuildingColumnsDuotone,
    },
  },
  handHoldingBox: {
    defaultLabel: 'Hand Holding Box',
    variants: {
      regular: faHandHoldingBox,
      light: faHandHoldingBoxLight,
      solid: faHandHoldingBoxSolid,
    },
  },
  Files: {
    defaultLabel: 'Files',
    variants: {
      regular: faFiles,
      light: faFilesLight,
      solid: faFilesSolid,
    },
  },
  Window: {
    defaultLabel: 'Window',
    variants: {
      regular: faWindow,
      light: faWindowLight,
    },
  },
  Tasks: {
    defaultLabel: 'Tasks',
    variants: {
      regular: faTasks,
      light: faTasksLight,
    },
  },
  TrafficLight: {
    defaultLabel: 'Traffic light',
    variants: {
      regular: faTrafficLight,
      light: faTrafficLightLight,
    },
  },
  Trash: {
    defaultLabel: 'Trash',
    variants: {
      regular: faTrash,
      light: faTrashLight,
      solid: faTrashSolid,
    },
  },
  Envelope: {
    defaultLabel: 'Envelope',
    variants: {
      regular: faEnvelope,
      light: faEnvelopeLight,
    },
  },
  Plus: {
    defaultLabel: 'Plus',
    variants: {
      regular: faPlus,
      light: faPlusLight,
      solid: faPlusSolid,
    },
  },
  ChevronRight: {
    defaultLabel: 'Chevron right',
    variants: {
      regular: faChevronRight,
      light: faChevronRightLight,
      solid: faChevronRightSolid,
    },
  },
  ChevronLeft: {
    defaultLabel: 'Chevron Left',
    variants: {
      regular: faChevronLeft,
      light: faChevronLeftLight,
      solid: faChevronLeftSolid,
    },
  },
  ArrowUpRightFromSquare: {
    defaultLabel: 'Arrow up right from square',
    variants: {
      regular: faArrowUpRightFromSquare,
      light: faArrowUpRightFromSquareLight,
    },
  },
  QuestionCircle: {
    defaultLabel: 'Question circle',
    variants: {
      regular: faQuestionCircle,
      light: faQuestionCircleLight,
      solid: faQuestionCircleSolid,
    },
  },
  Pen: {
    defaultLabel: 'Pen',
    variants: {
      regular: faPen,
      light: faPenLight,
      solid: faPenSolid,
    },
  },

  penLine: {
    defaultLabel: 'Pen line',
    variants: {
      regular: faPenLine,
      light: faPenLineLight,
      duotone: faPenLineDuotone,
    },
  },
  print: {
    defaultLabel: 'Print',
    variants: {
      regular: faPrint,
      solid: faPrintSolid,
    },
  },
  Text: {
    defaultLabel: 'Text',
    variants: {
      regular: faText,
      light: faTextLight,
      solid: faTextSolid,
    },
  },
  arrowRight: {
    defaultLabel: 'Arrow Right',
    variants: {
      regular: faArrowRight,
      light: faArrowRightLight,
      solid: faArrowRightSolid,
    },
  },
  user: {
    defaultLabel: 'User',
    variants: {
      regular: faUser,
      light: faUserLight,
      solid: faUserSolid,
    },
  },
  search: {
    defaultLabel: 'Search',
    variants: {
      regular: faSearch,
      light: faSearchLight,
      solid: faSearchSolid,
    },
  },
  trash: {
    defaultLabel: 'Trash',
    variants: {
      regular: faTrashCan,
      light: faTrashCanLight,
      solid: faTrashCanSolid,
    },
  },
  fileCheck: {
    defaultLabel: 'File Check',
    variants: {
      regular: faFileCheck,
    },
  },
  Eye: {
    defaultLabel: 'Search',
    variants: {
      regular: faEye,
      light: faEyeLight,
      solid: faEyeSolid,
    },
  },
  EyeSlash: {
    defaultLabel: 'HideSearch',
    variants: {
      regular: faEyeSlash,
      light: faEyeSlashLight,
      solid: faEyeSlashSolid,
    },
  },
  PaperPlaneTop: {
    defaultLabel: 'Paper Plane Top',
    variants: {
      regular: faPaperPlaneTop,
      light: faPaperPlaneTopLight,
      solid: faPaperPlaneTopSolid,
    },
  },
  ArrowDownToLine: {
    defaultLabel: 'Arrow Down To Line',
    variants: {
      regular: faArrowDownToLine,
      light: faArrowDownToLineLight,
      solid: faArrowDownToLineSolid,
    },
  },
  ArrowUpArrowDown: {
    defaultLabel: 'Arrow Down To Line',
    variants: {
      regular: faArrowUpArrowDown,
      light: faArrowUpArrowDownLight,
    },
  },

  filter: {
    defaultLabel: 'Filter',
    variants: {
      regular: faFilter,
      light: faFilterLight,
      solid: faFilterSolid,
    },
  },
  badgePercent: {
    defaultLabel: 'Badge Percent',
    variants: {
      regular: faBadgePercent,
      solid: faBadgePercentSolid,
    },
  },
  CirclePlay: {
    defaultLabel: 'Circle Play',
    variants: {
      regular: faCirclePlay,
      solid: faCirclePlaySolid,
    },
  },
  WavePulse: {
    defaultLabel: 'Wave Pulse',
    variants: {
      regular: faWavePulse,
      light: faWavePulseLight,
      solid: faWavePulseSolid,
    },
  },
  FastForward: {
    defaultLabel: 'Fast forward',
    variants: {
      regular: faFastForwardLight,
      light: faFastForwardLight,
    },
  },
  House: {
    defaultLabel: 'House',
    variants: {
      regular: faHouse,
    },
  },
  UpFromLine: {
    defaultLabel: 'Up From Line',
    variants: {
      regular: faUpFromLine,
      light: faUpFromLineLight,
      solid: faUpFromLineSolid,
    },
  },
  scaleBalanced: {
    defaultLabel: 'Scale Balanced',
    variants: {
      regular: faScaleBalanced,
      light: faScaleBalancedLight,
      solid: faScaleBalancedSolid,
    },
  },
  Tags: {
    defaultLabel: 'Tags',
    variants: {
      regular: faTags,
    },
  },
  arrowUp: {
    defaultLabel: 'Arrow Up',
    variants: {
      regular: faArrowUpRegular,
      solid: faArrowUpSolid,
    },
  },
  arrowTrendUp: {
    defaultLabel: 'Arrow Trend Up',
    variants: {
      regular: faArrowTrendUp,
    },
  },
  // Sort-direction glyphs, matching the Library toolbar's sort control.
  arrowUpShortWide: {
    defaultLabel: 'Sort ascending',
    variants: {
      regular: faArrowUpShortWide,
      light: faArrowUpShortWideLight,
      solid: faArrowUpShortWideSolid,
    },
  },
  arrowDownShortWide: {
    defaultLabel: 'Sort descending',
    variants: {
      regular: faArrowDownShortWide,
      light: faArrowDownShortWideLight,
      solid: faArrowDownShortWideSolid,
    },
  },
  shield: {
    defaultLabel: 'Shield',
    variants: {
      regular: faShield,
    },
  },
  shieldCheck: {
    defaultLabel: 'Shield Check',
    variants: {
      regular: faShieldCheck,
      solid: faShieldCheckSolid,
    },
  },
  shieldExclamation: {
    defaultLabel: 'Shield Exclamation',
    variants: {
      regular: faShieldExclamation,
      solid: faShieldExclamationSolid,
    },
  },
  rabbitRunning: {
    defaultLabel: 'Rabbit Running',
    variants: {
      regular: faRabbitRunning,
    },
  },
  circlePause: {
    defaultLabel: 'Circle Pause',
    variants: {
      regular: faCirclePause,
    },
  },
  quoteRight: {
    defaultLabel: 'Quote right',
    variants: {
      light: faQuoteRightLight,
      regular: faQuoteRight,
      solid: faQuoteRightSolid,
      duotone: faQuoteRightDuotone,
    },
  },
  penToSquare: {
    defaultLabel: 'Pen to square',
    variants: {
      regular: faPenToSquare,
    },
  },
  UserCheck: {
    defaultLabel: 'User Check',
    variants: {
      regular: faUserCheck,
      light: faUserCheckLight,
      solid: faUserCheckSolid,
    },
  },
  resize: {
    defaultLabel: 'Grip lines vertical',
    variants: {
      regular: faGripLinesVertical,
      solid: faGripLinesVerticalSolid,
    },
  },
  expand: {
    defaultLabel: 'Up right and down left from center',
    variants: {
      regular: faUpRightAndDownLeftFromCenter,
      solid: faArrowUpRightAndArrowDownLeftFromCenter,
    },
  },
  expandOn: {
    defaultLabel: 'Arrow up right and down left from center',
    variants: {
      regular: faArrowUpRightAndArrowDownLeftFromCenter,
    },
  },
  counterargument: {
    defaultLabel: 'Layer group',
    variants: {
      regular: faLayerGroup,
    },
  },
  fileLines: {
    defaultLabel: 'File lines',
    variants: {
      regular: faFileLines,
      solid: faFileLinesSolid,
      douotone: faFileLinesDuotone,
    },
  },
  goBack: {
    defaultLabel: 'Arrow turn left',
    variants: {
      regular: faArrowToLeft,
    },
  },
  arrowDownLeft: {
    defaultLabel: 'Arrow turn down left',
    variants: {
      regular: faArrowTurnDownLeft,
      solid: faArrowTurnDownLeftSolid,
      light: faArrowTurnDownLeftLight,
    },
  },
  magicWandSparkles: {
    defaultLabel: 'AI writing tool',
    variants: {
      regular: faMagicWandSparkles,
      solid: faMagicWandSparklesSolid,
    },
  },
  arrowLeftLong: {
    defaultLabel: 'Arrow left long',
    variants: {
      regular: faArrowLeftLong,
    },
  },
  moneyCheckPen: {
    defaultLabel: 'Money check pen',
    variants: {
      regular: faMoneyCheckPen,
      light: faMoneyCheckPenLight,
    },
  },
  bookmark: {
    defaultLabel: 'bookmark',
    variants: {
      regular: faBookmark,
      solid: faBookmarkSolid,
    },
  },
  bars: {
    defaultLabel: 'bars',
    variants: {
      regular: faBars,
    },
  },
  barsSort: {
    defaultLabel: 'bars sort',
    variants: {
      regular: faBarsSort,
    },
  },
  fire: {
    defaultLabel: 'fire',
    variants: {
      regular: faFire,
    },
  },
  flagPennant: {
    defaultLabel: 'flag pennant',
    variants: {
      regular: faFlagPennant,
      solid: faFlagPennantSolid,
    },
  },
  play: {
    defaultLabel: 'Play',
    variants: {
      regular: faPlay,
      solid: faPlaySolid,
    },
  },
  barsFilter: {
    defaultLabel: 'Bars Filter',
    variants: {
      regular: faBarsFilter,
      light: faBarsFilterLight,
      solid: faBarsFilterSolid,
    },
  },
  language: {
    defaultLabel: 'Language',
    variants: {
      regular: faLanguage,
      solid: faLanguageSolid,
      duotone: faLanguageDuotone,
    },
  },
  notebook: {
    defaultLabel: 'notebook',
    variants: {
      regular: faNotebook,
    },
  },
  quote: {
    defaultLabel: 'quote',
    variants: {
      regular: faQuoteRightAlt,
    },
  },
  paperclip: {
    defaultLabel: 'paperclip',
    variants: {
      regular: faPaperclip,
    },
  },
  grid2Plus: {
    defaultLabel: 'grid2plus',
    variants: {
      regular: faGrid2Plus,
      solid: faGrid2PlusSolid,
      duotone: faGrid2PlusDuotone,
      light: faGrid2PlusLight,
    },
  },
  circleChervonUp: {
    defaultLabel: 'chevron circle up',
    variants: {
      regular: faCircleChevronUp,
      solid: faCircleChevronUpSolid,
    },
  },
  circleChevronDown: {
    defaultLabel: 'chevron circle down',
    variants: {
      regular: faCircleChevronDown,
      solid: faCircleChevronDownSolid,
    },
  },
  circleChevronRight: {
    defaultLabel: 'chevron circle right',
    variants: {
      regular: faCircleChevronRight,
      solid: faCircleChevronRightSolid,
    },
  },
  circleChevronLeft: {
    defaultLabel: 'chevron circle left',
    variants: {
      regular: faCircleChevronLeft,
      solid: faCircleChevronLeftSolid,
    },
  },
  grid: {
    defaultLabel: 'grid',
    variants: {
      regular: faGrid,
      solid: faGridSolid,
    },
  },
  zoomIn: {
    defaultLabel: 'zoom In',
    variants: {
      light: faMagnifyingGlassPlus,
      solid: faMagnifyingGlassPlusSolid,
      regular: faMagnifyingGlassPlusRegular,
    },
  },
  zoomOut: {
    defaultLabel: 'zoom Out',
    variants: {
      light: faMagnifyingGlassMinus,
      solid: faMagnifyingGlassMinusSolid,
      regular: faMagnifyingGlassMinusRegular,
    },
  },
  fullscreen: {
    defaultLabel: 'full screen',
    variants: {
      regular: faExpand,
      solid: faExpandSolid,
    },
  },
  bullhorn: {
    defaultLabel: 'bullhorn',
    variants: {
      regular: faBullhorn,
    },
  },
  simpleSlider: {
    defaultLabel: 'simple slider',
    variants: {
      regular: faSlidersSimple,
      solid: faSlidersSimpleSolid,
    },
  },
  lockKeyHole: {
    defaultLabel: 'lock key hole',
    variants: {
      regular: faLockKeyhole,
      solid: faLockKeyHoleSolid,
    },
  },
  unlock: {
    defaultLabel: 'unlock',
    variants: {
      regular: faUnlock,
      solid: faUnlockSolid,
    },
  },
  unlockKeyHole: {
    defaultLabel: 'unlock key hole',
    variants: {
      regular: faUnlockKeyhole,
      solid: faUnlockKeyholeSolid,
    },
  },
  messageLine: {
    defaultLabel: 'message line',
    variants: {
      regular: faMessageLines,
      light: faMessageLinesLight,
      solid: faMessageLinesSolid,
    },
  },
  messageBot: {
    defaultLabel: 'message bot',
    variants: {
      regular: faMessageBot,
    },
  },
  circleMinus: {
    defaultLabel: 'circle minus',
    variants: {
      regular: faCircleMinus,
      solid: faCircleMinusSolid,
    },
  },
  checkToSlot: {
    defaultLabel: 'check to slot',
    variants: {
      light: faCheckToSlotLight,
      regular: faCheckToSlot,
      solid: faCheckToSlotSolid,
    },
  },
  penFancy: {
    defaultLabel: 'pen fancy',
    variants: {
      light: faPenFancyLight,
      regular: faPenFancy,
      solid: faPenFancySolid,
    },
  },
  book: {
    defaultLabel: 'book',
    variants: {
      light: faBookLight,
      regular: faBook,
    },
  },
  list: {
    defaultLabel: 'List',
    variants: {
      light: faListLight,
      regular: faList,
      solid: faListSolid,
    },
  },
  listUl: {
    defaultLabel: 'Unordered List',
    variants: {
      light: faListUlLight,
      regular: faListUl,
      solid: faListUlSolid,
    },
  },
  listOl: {
    defaultLabel: 'Ordered List',
    variants: {
      light: faListOlLight,
      regular: faListOl,
      solid: faListOlSolid,
    },
  },
  ArrowDown: {
    defaultLabel: 'Arrow Down',
    variants: {
      regular: faArrowDown,
      light: faArrowDownLight,
      solid: faArrowDownSolid,
    },
  },
  ArrowTop: {
    defaultLabel: 'Arrow Top',
    variants: {
      regular: faArrowUpRegular,
      light: faArrowUpLight,
      solid: faArrowUpSolid,
    },
  },
  AngleUp: {
    defaultLabel: 'Angle Up',
    variants: {
      regular: faAngleUp,
      light: faAngleUpLight,
      solid: faAngleUpSolid,
    },
  },
  AngleLeft: {
    defaultLabel: 'Angle Left',
    variants: {
      regular: faAngleLeft,
      light: faAngleLeftLight,
      solid: faAngleLeftSolid,
    },
  },
  anglesRight: {
    defaultLabel: 'Angles Right',
    variants: {
      regular: faAnglesRight,
      solid: faAnglesRightSolid,
    },
  },
  wandMagicSparkles: {
    defaultLabel: 'Wand Magic Sparkles',
    variants: {
      regular: faWandMagicSparkles,
    },
  },
  sparkle: {
    defaultLabel: 'Sparkle',
    variants: {
      light: faSparkleLight,
      regular: faSparkle,
      solid: faSparkleSolid,
      duotone: faSparkleDuotone,
    },
  },
  anglesLeft: {
    defaultLabel: 'Angles Left',
    variants: {
      regular: faAnglesLeft,
      solid: faAnglesLeftSolid,
    },
  },
  arrowRepeat: {
    defaultLabel: 'Arrow Repeat',
    variants: {
      regular: faArrowsRepeat,
      light: faArrowsRepeatLight,
      duotone: faArrowsRepeatDuotone,
    },
  },
  AngleDown: {
    defaultLabel: 'Angle Down',
    variants: {
      regular: faAngleDown,
      light: faAngleDownLight,
    },
  },
  paste: {
    defaultLabel: 'Paste',
    variants: {
      regular: faPaste,
      light: faPasteLight,
    },
  },
  clone: {
    defaultLabel: 'Clone',
    variants: {
      regular: faClone,
      light: faCloneLight,
    },
  },
  selectAll: {
    defaultLabel: 'Square Dashed Circle Plus',
    variants: {
      regular: faSquareDashedCirclePlus,
      light: faSquareDashedCirclePlusLight,
    },
  },
  table: {
    defaultLabel: 'Table',
    variants: {
      regular: faTable,
      light: faTableLight,
    },
  },
  tableColumn: {
    defaultLabel: 'Table Column',
    variants: {
      regular: faTableColumns,
      light: faTableColumnsLight,
    },
  },
  palette: {
    defaultLabel: 'Palette',
    variants: {
      regular: faPalette,
      solid: faPaletteSolid,
    },
  },
  alignLeft: {
    defaultLabel: 'Align left',
    variants: {
      regular: faAlignLeft,
      solid: faAlignLeftSolid,
    },
  },
  alignCenter: {
    defaultLabel: 'Align Center',
    variants: {
      regular: faAlignCenter,
      solid: faAlignCenterSolid,
    },
  },
  alignRight: {
    defaultLabel: 'Align Right',
    variants: {
      regular: faAlignRight,
      solid: faAlignRightSolid,
    },
  },
  alignJustify: {
    defaultLabel: 'Align Justify',
    variants: {
      regular: faAlignJustify,
      solid: faAlignJustifySolid,
    },
  },
  loader: {
    defaultLabel: 'Loader',
    variants: {
      regular: faLoader,
      solid: faLoaderSolid,
      light: faLoaderLight,
    },
  },
  gripDotVertical: {
    defaultLabel: 'Grip Vertical',
    variants: {
      regular: faGripDotsVertical,
      solid: faGripDotsVerticalSolid,
    },
  },
  link: {
    defaultLabel: 'Link',
    variants: {
      regular: faLink,
    },
  },
  image: {
    defaultLabel: 'Image',
    variants: {
      regular: faImage,
      light: faImageLight,
      solid: faImageSolid,
    },
  },
  squareLeft: {
    defaultLabel: 'Square left',
    variants: {
      regular: faSquareLeft,
      solid: faSquareLeftSolid,
    },
  },
  squareRight: {
    defaultLabel: 'Square Right',
    variants: {
      regular: faSquareRight,
      solid: faSquareRightSolid,
    },
  },
  arrowLeftToLine: {
    defaultLabel: 'Arrow left to line',
    variants: {
      regular: faArrowLeftToLine,
      solid: faArrowLeftToLineSolid,
    },
  },
  arrowRightToLine: {
    defaultLabel: 'Arrow right to line',
    variants: {
      regular: faArrowRightToLine,
      solid: faArrowRightToLineSolid,
    },
  },
  arrowUpToLine: {
    defaultLabel: 'Arrow up to line',
    variants: {
      regular: faArrowUpToLine,
      solid: faArrowUpToLineSolid,
    },
  },
  textSlash: {
    defaultLabel: 'Text Slash',
    variants: {
      regular: faTextSlash,
    },
  },
  minimize: {
    defaultLabel: 'Minimize',
    variants: {
      regular: faArrowDownLeftAndArrowUpRightToCenter,
      solid: faArrowDownLeftAndArrowUpRightToCenterSolid,
    },
  },
  mention: {
    defaultLabel: 'At',
    variants: {
      regular: faAt,
      solid: faAtSolid,
    },
  },
  listTimeline: {
    defaultLabel: 'List Timeline',
    variants: {
      regular: faListTimeline,
      solid: faListTimelineSolid,
    },
  },
  userGroup: {
    defaultLabel: 'User Group',
    variants: {
      regular: faUserGroup,
      light: faUserGroupLight,
      duotone: faUserGroupDuotone,
    },
  },
  faCircleUser: {
    defaultLabel: 'User Circle',
    variants: {
      regular: faCircleUser,
    },
  },
  penClip: {
    defaultLabel: 'Pen Clip',
    variants: {
      regular: faPenClip,
    },
  },
  capsules: {
    defaultLabel: 'Capsules',
    variants: {
      regular: faCapsules,
      solid: faCapsulesSolid,
    },
  },
  messagePlus: {
    defaultLabel: 'Message plus',
    variants: {
      regular: faMessagePlus,
    },
  },
  messageDot: {
    defaultLabel: 'Message dot',
    variants: {
      regular: faMessageDots,
      light: faMessageDotsLight,
      solid: faMessageDotsSolid,
    },
  },
  listTree: {
    defaultLabel: 'List Tree',
    variants: {
      regular: faListTree,
      light: faListTreeLight,
      duotone: faListTreeDuotone,
    },
  },
  arrowUpLeft: {
    defaultLabel: 'Arrow Up Left',
    variants: {
      regular: faArrowUpLeft,
      light: faArrowUpLeftLight,
    },
  },
  creditCard: {
    defaultLabel: 'Credit Card',
    variants: {
      regular: faCreditCard,
    },
  },
  squareList: {
    defaultLabel: 'Square List',
    variants: {
      regular: faSquareList,
    },
  },
  arrowsRetweet: {
    defaultLabel: 'Retweet',
    variants: {
      regular: faArrowsRetweet,
      light: faArrowsRetweetLight,
      solid: faArrowsRetweetSolid,
    },
  },
  objectUngroup: {
    defaultLabel: 'Object Ungroup',
    variants: {
      regular: faObjectUngroup,
      light: faObjectUngroupLight,
      solid: faObjectUngroupSolid,
    },
  },
  asterisk: {
    defaultLabel: 'Asterisk',
    variants: {
      regular: faAsterisk,
      solid: faAsteriskSolid,
      light: faAsteriskLight,
    },
  },
  folder: {
    defaultLabel: 'Folder',
    variants: {
      light: faFolderOpenLight,
      regular: faFolderOpen,
      douotone: faFolderOpenDuotone,
    },
  },
  ballotCheck: {
    defaultLabel: 'Ballot Check',
    variants: {
      regular: faBallotCheck,
      light: faBallotCheckLight,
    },
  },
  grid2: {
    defaultLabel: 'Grid 2',
    variants: {
      regular: faGrid2,
    },
  },
  chevronsLeft: {
    defaultLabel: 'Chevrons Left',
    variants: {
      regular: faChevronsLeft,
    },
  },
  chevronsRight: {
    defaultLabel: 'Chevrons Right',
    variants: {
      regular: faChevronsRight,
    },
  },
  textSize: {
    defaultLabel: 'Text Size',
    variants: {
      regular: faTextSize,
    },
  },
  telescope: {
    defaultLabel: 'Telescope',
    variants: {
      regular: faTelescope,
      solid: faTelescopeSolid,
      duotone: faTelescopeDuotone,
    },
  },
  IconReference: {
    defaultLabel: 'References',
    variants: {
      regular: faSquareQuote,
    },
  },
  IconNewDoc: {
    defaultLabel: 'Circle Plus',
    variants: {
      regular: faFileCirclePlus,
    },
  },
  IconLimit: {
    defaultLabel: 'Limit',
    variants: {
      duotone: faGaugeSimpleMaxDuotone,
      regular: faGaugeSimpleMax,
    },
  },
  IconICursor: {
    defaultLabel: 'I cursor',
    variants: {
      regular: faICursor,
    },
  },
  IconAI: {
    defaultLabel: 'AI',
    variants: {
      regular: faMicrochipAi,
    },
  },
  IconScreenUser: {
    defaultLabel: 'Icon Screen User',
    variants: {
      regular: faScreenUsersDuotone,
      duotone: faScreenUsersDuotone,
    },
  },
  IconToolbox: {
    defaultLabel: 'Icon Toolbox',
    variants: {
      regular: faToolboxDuotone,
      duotone: faToolboxDuotone,
    },
  },
  IconWrench: {
    defaultLabel: 'Icon Wrench',
    variants: {
      regular: faWrenchDuotone,
      duotone: faWrenchDuotone,
    },
  },
  IconFingerprint: {
    defaultLabel: 'Fingerprint',
    variants: {
      regular: faFingerprint,
    },
  },
  IconCommentQuestion: {
    defaultLabel: 'Comment Question',
    variants: {
      regular: faCommentQuestion,
    },
  },
  IconRocketLaunch: {
    defaultLabel: 'Rocket Launch',
    variants: {
      regular: faRocketLaunch,
    },
  },
} as const;

export type SolidIconName = {
  [K in keyof typeof icons]: 'solid' extends keyof (typeof icons)[K]['variants']
    ? K
    : never;
}[keyof typeof icons];

export type RegularIconName = {
  [K in keyof typeof icons]: 'regular' extends keyof (typeof icons)[K]['variants']
    ? K
    : never;
}[keyof typeof icons];

export type LightIconName = {
  [K in keyof typeof icons]: 'light' extends keyof (typeof icons)[K]['variants']
    ? K
    : never;
}[keyof typeof icons];

export type DuotoneIconName = {
  [K in keyof typeof icons]: 'duotone' extends keyof (typeof icons)[K]['variants']
    ? K
    : never;
}[keyof typeof icons];

export type IconName = keyof typeof icons;
export type IconVariant<TIconName extends IconName> =
  keyof (typeof icons)[TIconName]['variants'];

export const Icon = <
  TIconName extends keyof typeof icons,
  TIconVariant extends IconVariant<TIconName>,
>({
  name,
  variant,
  label,
  height,
  size,
  width,
  color,
}: {
  name: TIconName;
  variant: TIconVariant;
  label?: string;
  color?: string;
} & Pick<FontAwesomeIconProps, 'height' | 'size' | 'width'>): JSX.Element => {
  const iconName = icons[name];
  if (!iconName) {
    return <></>;
  }
  const icon = (iconName['variants'] as (typeof icons)[TIconName]['variants'])[
    variant
  ] as IconDefinition;

  return (
    <AccessibleIcon label={label ?? iconName['defaultLabel']}>
      <FontAwesomeIcon
        icon={icon}
        style={{
          color: color ?? 'currentColor',
        }}
        height={height}
        size={size}
        width={width}
      />
    </AccessibleIcon>
  );
};
